(() => {
  window.addEventListener('load', () => {
    /**
     * Films Carousel
     */
    new Swiper('.carousel--films .swiper', {
      spaceBetween: 16,
      slidesPerView: 1.2,
      breakpoints: {
        640: {
          slidesPerView: 2.6,
          spaceBetween: 18,
        },
      },
      navigation: {
        prevEl: '.button--prev',
        nextEl: '.button--next',
      },
    });

    /**
     * Kits Carousel
     */
    new Swiper('.carousel--film-kits .swiper', {
      spaceBetween: 16,
      slidesPerView: 1.2,
      breakpoints: {
        768: {
          slidesPerView: 2.6,
          spaceBetween: 24,
        },
        1280: {
          slidesPerView: 3.6,
        },
      },
      navigation: {
        prevEl: '.button--prev',
        nextEl: '.button--next',
      },
    });

    /**
     * Product Showcase Carousel
     */
    const showcaseCarousel = document.querySelector('.carousel--showcase .swiper');
    if (showcaseCarousel) {
      new Swiper(showcaseCarousel, {
        spaceBetween: 16,
        slidesPerView: 1.1,
        breakpoints: {
          640: {
            slidesPerView: 2.6,
            spaceBetween: 18,
          },
          1024: {
            slidesPerView: 3.1,
            spaceBetween: 18,
          },
        },
        navigation: {
          prevEl: document.querySelector('.carousel--showcase .button--prev'),
          nextEl: document.querySelector('.carousel--showcase .button--next'),
        },
      });
    }

    /**
     * Testimonial Carousel
     */
    const testimonialCarousel = document.querySelector('.carousel--testimonials .swiper');
    if (testimonialCarousel) {
      new Swiper(testimonialCarousel, {
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        autoHeight: true,
        navigation: {
          prevEl: document.querySelector('.carousel--testimonials .button--prev'),
          nextEl: document.querySelector('.carousel--testimonials .button--next'),
        },
      });
    }

    /**
     * Collections Carousel
     */
    new Swiper('.carousel--collections .swiper', {
      spaceBetween: 24,
      slidesPerView: 1.4,
      breakpoints: {
        580: {
          slidesPerView: 2.6,
        },
        768: {
          slidesPerView: 3.6,
        },
        1024: {
          slidesPerView: 4.2,
        },
      },
      navigation: {
        prevEl: '.button--prev',
        nextEl: '.button--next',
      },
    });

    /**
     * Product Showcase Carousel
     */
    const tutorCarousel = document.querySelector('.carousel--tutors .swiper');
    if (tutorCarousel) {
      new Swiper(tutorCarousel, {
        spaceBetween: 24,
        slidesPerView: 1.3,
        keyboard: {
          enabled: true,
        },
        breakpoints: {
          460: {
            slidesPerView: 1.8,
          },
          640: {
            slidesPerView: 2.1,
          },
          768: {
            slidesPerView: 2.8,
          },
          1024: {
            slidesPerView: 3.9,
          },
          1280: {
            slidesPerView: 4.1,
          },
        },
        navigation: {
          prevEl: document.querySelector('.carousel--tutors .button--prev'),
          nextEl: document.querySelector('.carousel--tutors .button--next'),
        },
      });
    }

    /**
     *  Collection Kits Carousel
     */
    new Swiper('.carousel--kits .swiper', {
      slidesPerView: 1,
      loop: true,
      centeredSlides: true,
      navigation: {
        prevEl: '.button--prev',
        nextEl: '.button--next',
      },
    });

    /**
     * Modal Carousel Slider
     */
    const modal_carousel = (window.modalCarousel = new Swiper('.carousel--modal-slider .swiper', {
      slidesPerView: 1,
      effect: 'fade',
      autoHeight: true,
      loop: true,
      fadeEffect: { crossFade: true },
      navigation: {
        prevEl: document.querySelector('.carousel--modal-slider .button--prev'),
        nextEl: document.querySelector('.carousel--modal-slider .button--next'),
      },
    }));

    /**
     * Product Media Carousel
     */
    const media_carousel = new Swiper('.carousel--media-carousel .swiper', {
      slidesPerView: 3.2,
      spaceBetween: 16,
      loop: true,
      watchSlidesProgress: true,
      breakpoints: {
        480: {
          slidesPerView: 4.5,
        },
        768: {
          slidesPerView: 5.5,
        },
        1024: {
          slidesPerView: 6,
        },
      },
    });

    /**
     * Product Media Slider
     */
    window.mediaSlider = new Swiper('.carousel--media-slider .swiper', {
      slidesPerView: 1,
      allowTouchMove: false,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      controller: {
        control: modal_carousel,
      },
      thumbs: {
        swiper: media_carousel,
      },
    });

    /**
     * Product Social Proof Carousel
     */
    const socialproofCarousel = document.querySelector('.carousel--socialproof .swiper');
    if (socialproofCarousel) {
      new Swiper(socialproofCarousel, {
        spaceBetween: 32,
        slidesPerView: 1.1,
        breakpoints: {
          640: {
            slidesPerView: 2.6,
          },
          1024: {
            slidesPerView: 3.1,
            spaceBetween: 24,
          },
          1280: {
            slidesPerView: 4.1,
          },
        },
        navigation: {
          prevEl: document.querySelector('.carousel--socialproof .button--prev'),
          nextEl: document.querySelector('.carousel--socialproof .button--next'),
        },
      });
    }

    /**
     * Goods Carousel
     */
    const goodsCarousels = document.querySelectorAll('.carousel--goods');
    goodsCarousels.forEach((carousel) => {
      if (carousel) {
        const swiper = carousel.querySelector('.swiper');

        new Swiper(swiper, {
          spaceBetween: 12,
          slidesPerView: 1.2,
          loop: true,
          //slidesOffsetBefore: 32, //TODO: test for regressions then remove.
          breakpoints: {
            640: {
              slidesPerView: 2.2,
              spaceBetween: 24,
            },
            1024: {
              slidesPerView: 3.2,
              spaceBetween: 24,
            },
            1440: {
              slidesPerView: 4.2,
              spaceBetween: 24,
            },
          },
          navigation: {
            prevEl: carousel.querySelector('.button--prev'),
            nextEl: carousel.querySelector('.button--next'),
          },
        });
      }
    });

    /**
     * Slideshow Carousel
     */

    const slideshows = document.querySelectorAll('.carousel--slideshow');
    slideshows.forEach((slideshow) => {
      new Swiper(slideshow.querySelector('.swiper'), {
        slidesPerView: 1,
        loop: true,
        navigation: {
          prevEl: slideshow.querySelector('.button--prev'),
          nextEl: slideshow.querySelector('.button--next'),
        },
        pagination: {
          el: slideshow.querySelector('.swiper-pagination'),
        },
      });
    });
  });
})();
